import { render, staticRenderFns } from "./BTP.vue?vue&type=template&id=50435015"
import script from "./BTP.vue?vue&type=script&lang=js"
export * from "./BTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports